module.exports = __webpack_public_path__ + "img/sign-3.23795381.jpg";